// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:44:55

export default {
  "id": "just-slap-it",
  "slug": "just-slap-it",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/163403f90400442c90dafc5d04838441-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/163403f90400442c90dafc5d04838441/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Just Slap It!",
      "description": "Just Slap It is a fun and lighthearted slap-based game where timing and accuracy are key. Compete in slap battles, perfect your timing, and climb the leaderboard to showcase your skills.\n\nWith simple controls and engaging gameplay, challenge yourself to out-slap opponents and rise to the top. Unlock upgrades and enjoy quick, casual fun anytime.",
      "instructions": "Just click/tap on screen to slap!",
      "genres": [
        "Battle",
        "Casual"
      ],
      "tags": [
        "1player",
        "3d",
        "fighting",
        "relaxing"
      ]
    },
    "zh-CN": {
      "title": "只拍一下！",
      "description": "《Just Slap It》是一款有趣且轻松的击掌游戏，精准度和时机至关重要。参与击掌战斗，磨练你的时机感，登上排行榜展示你的技巧。\n\n操作简单，游戏吸引人，挑战自己超越对手，攀登顶峰。解锁升级，享受随时随地的快速休闲乐趣。",
      "instructions": "只需点击/轻触屏幕即可打巴掌！",
      "genres": [
        "战斗",
        "休闲"
      ],
      "tags": [
        "1玩家",
        "3D",
        "格斗",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "只是拍它！",
      "description": "《只是拍它》是一款有趣且輕鬆的拍打遊戲，時間感和準確性至關重要。參加拍打大戰，磨練你的時間感，並登上排行榜展現你的技巧。\n\n簡單的操作和引人入勝的遊戲玩法，挑戰自己超越對手，奪得冠軍。解鎖升級並享受隨時隨地的快速輕鬆樂趣。",
      "instructions": "只需點擊/輕觸螢幕即可掃臉！",
      "genres": [
        "戰鬥",
        "休闲"
      ],
      "tags": [
        "1玩家",
        "3D",
        "格鬥",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "只是打它！",
      "description": "「Just Slap It」是一款有趣又輕鬆的打巴掌遊戲，時間和準確性是關鍵。參加打巴掌比賽，練習你的時間感，並在排行榜上攀升，展示你的技巧。\n\n遊戲操作簡單，遊戲過程吸引人，挑戰自己超越對手，奪取冠軍。解鎖升級，享受隨時隨地的快樂遊戲時光。",
      "instructions": "只需按鍵或觸控螢幕掴巴掌！",
      "genres": [
        "戰鬥",
        "休闲"
      ],
      "tags": [
        "1人玩",
        "3D",
        "格鬥",
        "輕鬆"
      ]
    },
    "ja": {
      "title": "ジャスティー・スラップ・イット！",
      "description": "「ジャストスラップ・イット」は、タイミングと正確さが鍵となる楽しい slap 基のゲームです。スラップバトルで競い合い、タイミングを磨き、ランクインを駆け上がってスキルを見せつけましょう。\n\n簡単なコントロールと魅力的なゲームプレイで、敵をスラップし過ぎないように挑戦し、トップに昇り詰めましょう。アップグレードを解除し、いつでも短時間で楽しい遊びを楽しみましょう。",
      "instructions": "画面をタップして叩いてください！",
      "genres": [
        "戦闘",
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "3D",
        "格闘",
        "リラックス"
      ]
    },
    "ko": {
      "title": "제발 쳐다!",
      "description": "Just Slap It은 시간과 정확성이 중요한 즐거운 스래프 기반 게임입니다. 스래프 전투에 참여하여 시간을 완벽히 맞추고 랭킹板上으로 올라가 자신의 기술을 보여주세요.\n\n간단한 조작과 흥미로운 게임성으로 자신을 도전하고 상대를 슬래프하는 것을 목표로 하세요. 업그레이드를 해놓고 언제든지 빠르고 쉬운 재미를 즐겨보세요.",
      "instructions": "화면을 클릭/터치하여 휘둘리기!",
      "genres": [
        "전투",
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "3D",
        "전투",
        "쉬운"
      ]
    },
    "fr": {
      "title": "Just Slap It !",
      "description": "Just Slap It est un jeu amusant et léger basé sur les coups de poing, où la timing et l'exactitude sont primordiales. Competez dans des battles de coups de poing, affinez votre timing, et montez sur le classement pour démontrer vos compétences.\n\nAvec des contrôles simples et un gameplay captivant, défiez-vous pour surpasser vos adversaires et grimper en haut du classement. Débloquez des améliorations et profitez de cette distraction rapide et facile à tout moment.",
      "instructions": "Cliquez/touchez l'écran pour claquer !",
      "genres": [
        "Bataille",
        "Occasionnel"
      ],
      "tags": [
        "1 joueur",
        "3D",
        "combat",
        "apaisant"
      ]
    }
  }
};
